module.exports = __webpack_public_path__ + "img/logo.c2939842.png";